export default "__VITE_ASSET__D4oX9TBg__"